import React, { useEffect, useState } from 'react'
import NumberField from '../../elements/form/NumberField'
import ModalActionButton from '../../elements/ModalActionButton'
import { useDispatch, useSelector } from 'react-redux'
import TextField from '../../elements/form/TextField'
import AutocompleteSelect from '../../elements/form/AutocompleteSelect'
import PlusIcon from '../../elements/icons/PlusIcon'
import { fetchStaff } from '../../../store/actions/staffActions'
import InlinePreloader from '../../elements/InlinePreloader'
import { createClassDivision } from '../../../store/actions/classesDivisionsActions'
import TrashIcon from '../../elements/icons/TrashIcon'
import { ERROR } from '../../../store/types'

const NewClassArm = ({classId, closeFunction}) => {
    const [armPayload, setArmPayload] = useState({})
    const [validationErrors, setValidationErrors] = useState({})
    const dispatch = useDispatch()
    const classesSelector = useSelector(state => state.classes)
    const staffSelector = useSelector(state => state.staff)
    const [classParents, setClassParents] = useState([''])

    useEffect(() => {
      dispatch(fetchStaff(`onboarded=true`, 0, 0))
    
      return () => {
        
      }
    }, [dispatch])

    const updateClassParent = (index, staffId) => {
        const temp = [...classParents]
        temp[index] = staffId
        setClassParents(temp)
    }

    const addClassParent = () => {
        const temp = [...classParents]
        temp.push('')
        setClassParents(temp)
    }

    const removeClassParent = (index) => {
        const temp = [classParents]
        temp.splice(index, 1)
        setClassParents(temp)
    }

    const validateForm = () => {
        let errors = {}

        if(!armPayload.label || armPayload.label === ''){
            errors.label = true
        }

        if(!armPayload.maxStudentCount || armPayload.maxStudentCount === ''){
            errors.maxStudentsCount = true
        }

        if(classParents.length > 1){
            classParents.forEach((element, elementIndex) => {
                if(element === ''){
                    errors[`parent-${elementIndex}`] = true
                }
            });
        } 
    
        setValidationErrors(errors)
    
        return errors
    }

    const pushClassArm = () => {
        if (Object.values(validateForm()).includes(true)) {
            dispatch({
                type: ERROR,
                error: {response: {data: {
                    message: 'Please check the highlighted fields'
                }}}
            })
            return
        }

        const payload = {
            class: classId,
            ...armPayload
        }

        if(classParents.length > 0 && classParents[0] !== ''){
            payload.classParents = classParents
        }
        dispatch(createClassDivision(payload))
    }

    return (
        <div className='w-full'>
            <div className=''>
                <TextField
                    inputLabel="Arm Label" 
                    inputPlaceholder={`Eg: A for BASIC7A`}
                    fieldId="fee-name" 
                    inputType="text" 
                    requiredField={true}
                    preloadValue={validationErrors.label || ''}
                    hasError={validationErrors && validationErrors.label} 
                    returnFieldValue={(value)=>{setArmPayload({...armPayload, label: value})}}
                />
            </div>
            <div className='mt-4 relative'>
                <NumberField
                    inputType="number" 
                    fieldId={`max-students`}
                    inputLabel="Maximum students for this arm" 
                    requiredField={true}
                    inputPlaceholder="Enter maximum number of students" 
                    preloadValue={armPayload?.maxStudentCount || ''}
                    hasError={validationErrors.maxStudentCount} 
                    returnFieldValue={(value)=>{setArmPayload({...armPayload, maxStudentCount: value})}}
                />
                <p className='text-xs text-gray-500 mt-[5px]'>The number of students in a class arm can not be above the amount you provide here.</p>
            </div>

            <h3 className='mt-4 font-[500]'>Class parents</h3>
            <p className='text-sm'>Select up to two class parents (administrators) for this class arm. (You can do this later if you are not ready now)</p>

            {staffSelector?.loadingStaff 
            ? 
                <InlinePreloader />
            : 
                <>
                    {staffSelector?.staffMembers?.staff?.length > 0 && classParents.map((parent, parentIndex)=>(<div key={parentIndex} className='mt-4 relative'>
                        {parentIndex > 0 && 
                            <button onClick={()=>{removeClassParent(parentIndex)}} className='absolute right-0 top-0 p-1 z-50 rounded bg-transparent mb-[10px] hover:bg-vcm-light-purple hover:bg-opacity-20 transition duration-200 text-gray-400 hover:text-vcm-purple'>
                                <TrashIcon className={`w-4 h-4`} />
                            </button>
                        }
                        <AutocompleteSelect
                            selectOptions = {staffSelector?.staffMembers?.staff}
                            inputLabel = "Class Parent"
                            requiredField={true}
                            titleField = "fullName"
                            displayImage = {false}
                            imageField = ""
                            placeholderText="Select a class parent"
                            fieldId = {`class-parent-${parentIndex}`}
                            preSelected={parent || ''}
                            preSelectedLabel='_id'
                            hasError = {validationErrors && validationErrors.classParents}
                            returnFieldValue={(value)=>{updateClassParent(parentIndex, value._id)}}
                        />
                    </div>))}
                    
                    {staffSelector?.staffMembers?.staff?.length === 0 && 
                        <div className='w-full mt-[20px] p-[15px] bg-gray-50 border border-gray-400 rounded-[8px] bg-opacity-'>
                            <h3 className='text-sm text-gray-600 font-[500] tracking-tight'>No eligible staff found</h3>
                            <p className='text-sm font-[500] text-gray-500'>The staff must be fully onboarded on this system and be enrolled as a full time employee</p>
                        </div>
                    }
                </>
            }

            {classParents.length < 2 && staffSelector?.staffMembers?.staff?.length > 0  && <div className='mt-3'>
                <button onClick={()=>{addClassParent()}} className='text-gray-600 bg-gray-200 rounded-[8px] p-3 transition duration-200 hover:bg-gray-100 border border-dashed border-gray-600 hover:text-vcm-dark-gray text-sm flex items-center gap-x-1'>
                    <PlusIcon className={`w-5 h-5`} /> Add another parent
                </button>
            </div>}

            <div className="mt-8 flex flex-row-reverse gap-x-4">
                <ModalActionButton
                    buttonLabel={`Create Class Arm`}
                    buttonAction={()=>{pushClassArm()}}
                    processing={classesSelector.creatingClassDivision}
                />

                <button
                    type="button"
                    className="inline-flex justify-center px-5 py-4 text-xs font-medium bg-transparent border border-transparent rounded-xl transition duration-200 hover:bg-opacity-10 hover:bg-secondary focus:outline-none"
                    onClick={closeFunction}
                >
                    Close
                </button>
                
            </div>
        </div>
    )
}

export default NewClassArm